import React, { SVGProps } from 'react';

export const CalendarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1818 10.1592H12.0909V7.06829H15.1818V10.1592ZM10.5454 10.1592H7.4545V7.06829H10.5454V10.1592ZM10.5454 14.7956H7.4545V11.7047H10.5454V14.7956ZM5.90913 10.1592H2.81822V7.06829H5.90913V10.1592ZM5.90913 14.7956H2.81822V11.7047H5.90913V14.7956ZM15.9545 2.43193H14.4091V0.886475H12.8636V4.75011H11.3182V2.43193H6.68182V0.886475H5.13636V4.75011H3.59091V2.43193H2.04545C1.19314 2.43193 0.5 3.12584 0.5 3.97738V15.5683C0.5 16.4206 1.19314 17.1137 2.04545 17.1137H15.9545C16.8069 17.1137 17.5 16.4206 17.5 15.5683V3.97738C17.5 3.12584 16.8069 2.43193 15.9545 2.43193Z"
      fill="currentColor"
    />
  </svg>
);
